import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Heirloom Stories Studio';
const BASE_URL = 'https://heirloomstorystudios.com';

export default function SEO({ title, description, path = '/', type = 'website', image }) {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Stories Meant to Last`;
  const fullUrl = `${BASE_URL}${path}`;
  const desc = description || 'Preserve your family\'s legacy through professionally guided interviews, video, audio, and curated heirlooms. Stories meant to last.';
  const ogImage = image || `${BASE_URL}/og-default.png`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
